<main>
	<a href="https://heydiag-rdv.fr"><img id="logo" src="/assets/logo_heydiag_transparent_15p.png"> </a>
	<router-outlet></router-outlet>
</main>